//exported methods 
export function isGroupObject(object) {
    var operator = Object.keys(object);
    if(operator && operator.length > 0 && isGroup(operator[0]))
        return true;
    else 
        return false;
}

export function getOperator(object) {
    var operator = Object.keys(object);
    if(operator) {
        let i = 0;
        while(i < operator.length) {
            if(operator[i].toUpperCase() !== 'GUID')
                return operator[i];
            i++;
        }
    }
}
export function getFirstValue(object) {
    return returnValue(object, 0);                 
}

export function getSecondValue(object) {
    return returnValue(object, 1);                 
}

export function setValue(object, index, newValue, attrBool) {
    var operator = getOperator(object);
    if(operator === '!') {
        if(!object[operator][0]['in']) {
            object[operator] = addInClause(object[operator]);
        }
        setValue(object[operator][0], index, newValue, attrBool);
        return;
    }
    var keys = Object.keys(object);
    if(keys && keys.length > 0) {
        let i = 0;
        while(i < keys.length) {
            if(keys[i].toUpperCase() !== 'GUID') {
                if(attrBool)
                    object[keys[i]][index] = { "var": newValue };
                else
                    object[keys[i]][index] = newValue != 'null' ? newValue : null;
                return;
            }
            i++;
        }
    }
}

export function createGuid() {
    return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
}

export function validateConditions(conditionGroup) {
    var valid = true;
    var childArray = conditionGroup[getOperator(conditionGroup)];

    if(childArray == null) return true;

    for(var i = 0; i < childArray.length; i++) {
        if(!isGroupObject(childArray[i])) {
            valid = isValidRule(childArray[i]);
        }
        else {
            valid = validateConditions(childArray[i]);
        }
        if(!valid) break;
    }

    return valid;
}

export function removeGuidsFromConditions(conditionGroup) {
   var childArray = conditionGroup[getOperator(conditionGroup)];
   if(childArray == null) return; 

   for(var i = childArray.length - 1; i >= 0; i--) {
       var currentCondition = childArray[i];  
       if(currentCondition["guid"] != null)
           delete currentCondition.guid;

       if(isGroupObject(currentCondition)) {
           var retCondition = removeGuidsFromConditions(childArray[i]);

           if(retCondition[getOperator(retCondition)].length > 0)
               childArray[i] = retCondition;
           else 
            childArray.splice(i,1);
       } 
   }

   conditionGroup[getOperator(conditionGroup)] = childArray;
   return conditionGroup;
}

export function printConditions(conditionGroup, level = 0) {
    var output = '';
    if(level === 0) {
        if(!isGroupObject(conditionGroup)) {
            var conditions = {'and': []};
            if(Object.keys(conditionGroup).length > 0)
                conditions['and'].push(structuredClone(conditionGroup));
            conditionGroup = conditions;       
        }
       
        output += '<div class="level0">';
    }
    
    var childArray = conditionGroup[getOperator(conditionGroup)];

    if(childArray == null) return; 

    for(var i = 0; i < childArray.length; i++) {  
        if(i > 0 && childArray.length > 1) {
            output += ' <b>' + getOperator(conditionGroup).toUpperCase() + '</b> ';
        }
        if(!isGroupObject(childArray[i])) {
            output += printRule(childArray[i]);
        }
        else {
            output += '( <div class="indent level' + (level+1) % 4 + '">' + printConditions(childArray[i], level+1) + '</div> )' ;
        }
    }

    if(level===0) output += '</div>';

    return output;
}

export function formatNotInConditions(conditions) {
    if(conditions != null && getOperator(conditions) != null) {
        conditions[getOperator(conditions)].forEach(cond => {
            if(cond['!'] && !cond['!'][0]['in']) {
                cond['!'] = addInClause(cond['!']);
            }
        });
    }

    return conditions;
}

//private methods 
function addInClause(condition) {
    condition = '[{"in":' + JSON.stringify(condition) + '}]';
    return JSON.parse(condition);
}

function isGroup(operator) {
    return (operator === 'or' || operator === 'and')
}

function isValidRule(object) {
    if(isGroupObject(object)) return false;
    
    return getFirstValue(object) != '' && getSecondValue(object) != '' && getOperator(object) != '';
}

function printRule(object) {
    if(isGroupObject(object)) return false;

    var operator = getOperator(object);

    const isFirstValueVariable = testIfVariable(object, 0);

    if(operator.toUpperCase() == 'IN') 
                // Add quotes if value is a string
        return (isFirstValueVariable ? '' : '"') + getFirstValue(object) + (isFirstValueVariable ? '' : '"') + 
                ' <b>IN LIST OF</b> ' + getSecondValue(object);
    else if(operator === '!' && getOperator(object['!'][0]).toUpperCase() === 'IN') 
                // Add quotes if value is a string
        return (isFirstValueVariable ? '' : '"') + getFirstValue(object['!'][0]) + (isFirstValueVariable ? '' : '"') + 
                ' <b>NOT IN LIST OF</b> ' + getSecondValue(object['!'][0]);
    else 
        return getFirstValue(object) + ' <b>' + operator + '</b> ' + getSecondValue(object);
}

function testIfVariable(object, index) {
    return getValue(object, index).var != null;
}

function returnValue(object, index) {
    const value = getValue(object, index);
    return value.var != null ? value.var : value;
}

function getValue(object, index) {
    var operator = getOperator(object);
    if(operator === '!')
        return returnValue(object[operator][0], index);
    var keys = Object.keys(object);
    if(keys && keys.length > 0) {
        var value = null;
        let i = 0;
        while(i < keys.length) {
            if(keys[i].toUpperCase() !== 'GUID')
                value = object[keys[i]][index];
            i++;
        }
        return value != null ? value : 'null';
    }
    else 
        return '';
}